module.exports = __webpack_public_path__ + "static/media/PlayStoreMobile.25ff5297.svg";